import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import FiisPageLayout from "components/company/v3/layouts/FiisPageLayout";
import { CompanyFinancialsTabEnum } from "components/company/v3/menu/enums";
import FiisFinancialsBox from "components/company/v3/realestatefunds/boxes/FiisFinancialsBox";
import FiiIssuerSeo from "components/company/v3/seo/FiiIssuerSeo";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import useSelfie from "lib/hooks/useSelfie";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { ISecurityCountry } from "types/graphqlTypes";

interface FiisFinancialsPageProps {
  tickerSymbol: string | null;
}

const FiisFinancialsPage: NextPage<FiisFinancialsPageProps> = function FiisFinancialsPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyFinancialsTabEnum>(Object.values(CompanyFinancialsTabEnum)).withDefault(
      CompanyFinancialsTabEnum.FINANCIALS,
    ),
  );
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <FiisPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="FIIs" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <FiiIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Balanços",
              description: "Título da página - SEO",
              id: "XY/aB+",
            })}
          />
          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Br}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Balanços", id: "wauBuH" })}
              description={intl.formatMessage({
                defaultMessage:
                  "Tabela de balanços completa e atualizada com os principais indicadores financeiros: Caixa, Imóveis, Rendimentos, Taxas, Rendimento/Cota, VPC, Dividend Yield (DY), dentre vários outros",
                id: "LNw0D3",
              })}
            />
          )}
          <FiisFinancialsBox tickerSymbol={normalizedTickerSymbol} tab={tab} onChangeTab={setTab} />
        </>
      </WrapperAmplitudeCompanyTab>
    </FiisPageLayout>
  );
};

FiisFinancialsPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default FiisFinancialsPage;
